import { CountUp } from 'countup.js';

Alpine.data('advocacyBanner', (endpoint, minCount = 0) => ({
	minCount,
	petitionCount: null,
	isCollapsableAreaExpanded: false,

	init() {
		this.handlePetitionCountAnimation();

		this.getCount();
	},
	expandCollapsableArea() {
		this.isCollapsableAreaExpanded = true;
	},
	getCount() {
		if (endpoint) {
			this.$store.aa
				.api(endpoint)
				.get()
				.json((response) => {
					if (response.success === true) {
						this.successful = true;
						this.petitionCount =
							response?.data?.num_signatures || response?.data?.num_sends;
					}
				});
		}
	},
	handlePetitionCountAnimation() {
		const counter = new CountUp(this.$refs.petitionCount, 0, {
			duration: 2,
		});

		counter.start();

		this.$watch('petitionCount', (value) => {
			counter.update(value);
		});
	},
}));
